module.exports = __webpack_public_path__ + "img/north-korea.4d5df50f.svg";